import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

interface ReportListVariables {
    reportId?: string;
    page?: number;
    login?: string;
    kassaId?: string | number;
    size?: number;
    from?: any;
    to?: any;
}

export interface AfmContryModel {
    code: string;
    name: string;
    order: number;
    citizenshipCode: number;
}

export interface BullionReportTotal {
    saleQty: number;
    saleGrams: number;
    saleSum: number;
    buybackQty: number;
    buybackGrams: number;
    buybackSum: number;
}

export interface BullionReportRow extends BullionReportTotal {
    gramm: number;
    name: string;
}

export interface BullionReportModel {
    periodFrom: string;
    periodTo: string;
    periodTitle: string;
    agreementNumber: string | null;
    agreementStart: string | null;
    depIds: number[];
    organizationName: string;
    directorName: string;
    rows: BullionReportRow[];
    total: BullionReportTotal;
}

export interface IndividualOperationsFilter {
    /** YYYY-MM-DD, границы включительно — так ручку прислал бэк (curl с голой датой) */
    from: string;
    to: string;
    /** Пустой список бэк трактует как «все отделения» — вызывающий код не шлёт его пустым */
    depIds: number[];
}

/** Операция по индивидуальному курсу и курсы, действовавшие в момент её установки */
export interface IndividualOperationModel {
    number: number;
    requestId: number;
    depId: number;
    departmentName: string;
    phone: string | null;
    /** UTC-момент */
    date: string;
    clientFullName: string | null;
    value: number;
    currency: string;
    clientRate: number;
    nbRate: number | null;
    standardRate: number | null;
    individualRate: number | null;
    amountKzt: number;
    initiator: string | null;
    treasurerFullName: string | null;
    status: string;
    isTechnical: boolean;
}

export class DocumentsCotroller {
    async getReportList(request: ReportListVariables) {
        return await server.post(`/CashierReport/report`, request.reportId ? {
            reportId: request.reportId
        } : {
            page: request.page,
            login: request.login,
            kassaId: request.kassaId,
            size: request?.size || 10,
            from: request?.from + "T00:00:00.000Z",
            to: request?.to + "T23:59:59.999Z",
        }, {
            baseURL: BACKEND_URL
        });
    }

    async getMomentReport(kassaId: number | string) {
        return await server.post(`/CashierReport/momentReport?kassaId=${kassaId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getReport(request: string | number) {
        return await server.get(`/CashierReport/report?reportId=${request}`, {
            baseURL: BACKEND_URL
        });
    }

    async getReportsByPeriod({ from, to, depsId }: { from: any, to: any, depsId: (string | number)[] }) {
        return await server.post(`/CashierReport/report-period`, {
            from: from + "T00:00:00.000Z",
            to: to + "T23:59:59.999Z",
            depIds: depsId
        }, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion11Requests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report11?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion8ByDepsRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from: string; to: string; }): Promise<Blob> {
        return await server.post(`Reports/application8?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                responseType: "blob",
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion8Json({ depIdArray, from, to }: { depIdArray: string[] | number[], from: string; to: string; }): Promise<BullionReportModel> {
        return await server.post(`Reports/application8-json?from=${from}&to=${to}`,
            depIdArray,
            {
                responseType: "json",
                baseURL: BACKEND_URL
            });
    }

    async getBreakReport({ from, to }: { from: string; to: string; }) {
        return await server.get(`Employee/breakReport?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            {
                responseType: "blob",
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion11ByDepsRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report11-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion13Requests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report13?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion13ByDepsRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report13-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion14Requests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report14?startDate=${from}T00%3A00%3A00.000Z&endDate=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion14ByDepsRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report14-by-deps?startDate=${from}T00%3A00%3A00.000Z&endDate=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion15Requests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report15?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion15ByDepsRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report15-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getApplicattion16Requests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report16?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion16ByDepsRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report16-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getKfmRequests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/kfm?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getAml1Requests(request: { year: string; halfYear: string | number; depId: string | number; }) {
        return await server.get(`Reports/aml-1/${request.year}/${request.halfYear}/${request.depId}`, {
            baseURL: BACKEND_URL
        });
    }

    async getAml1ByDepsRequests({ depIdArray, year, halfYear, }: { year: string; halfYear: string | number; depIdArray: string[] | number[]; }) {
        return await server.post(`Reports/aml-1-by-deps?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml2Requests(request: { year: string; halfYear: string | number; depId: string | number; }) {
        return await server.get(`Reports/aml-2/${request.year}/${request.halfYear}/${request.depId}`, {
            baseURL: BACKEND_URL
        });
    }

    async getAml2ByDepsRequests({ depIdArray, year, halfYear, }: { year: string; halfYear: string | number; depIdArray: string[] | number[]; }) {
        return await server.post(`Reports/aml-2-by-deps?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml3Requests(request: { year: string; halfYear: string | number; depId: string | number; }) {
        return await server.get(`Reports/aml-3/${request.year}/${request.halfYear}/${request.depId}`, {
            baseURL: BACKEND_URL
        });
    }

    async getAml3ByDepsRequests({ depIdArray, year, halfYear, }: { year: string; halfYear: string | number; depIdArray: string[] | number[]; }) {
        return await server.post(`Reports/aml-3-by-deps?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getApplicattion13XmlRequests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report13xml?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion13ByDepsXmlRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report13xmlByDeps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion13XmlJsonRequests({ depIdArray, from, to }: { from?: any; to?: any; depIdArray: number[]; }) {
        return await server.post(`Reports/json/report13-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getApplicattion14XmlRequests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report14xml?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion14ByDepsXmlRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report14xml-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion14XmlJsonRequests({ depIdArray, from, to }: { from?: any; to?: any; depIdArray: number[]; }) {
        return await server.post(`Reports/json/report14-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getApplicattion16XmlRequests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`Reports/report16xml?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z&depId=${depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getApplicattion16ByDepsXmlRequests({ depIdArray, from, to }: { depIdArray: string[] | number[], from?: any; to?: any; }) {
        return await server.post(`Reports/report16xml-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            });
    }

    async getApplicattion16XmlJsonRequests({ depIdArray, from, to }: { from?: any; to?: any; depIdArray: number[]; }) {
        return await server.post(`Reports/json/report16-by-deps?from=${from}T00%3A00%3A00.000Z&to=${to}T23%3A59%3A59.999Z`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml1XmlRequests(request: { year: string; halfYear: string | number; depId: string | number; }) {
        return await server.post(`Reports/aml1xml?year=${request.year}&half=${request.halfYear}&depId=${request.depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getAml1XmlByDepsRequests({ depIdArray, year, halfYear, }: { year: string; halfYear: string | number; depIdArray: string[] | number[]; }) {
        return await server.post(`Reports/aml-1-by-deps-xml?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml1XmlJsonRequests({ depIdArray, year, halfYear }: { year: string; halfYear: string | number; depIdArray: number[]; }) {
        return await server.post(`Reports/json/aml1-by-deps?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml2XmlRequests(request: { year: string; halfYear: string | number; depId: string | number; }) {
        return await server.post(`Reports/aml2xml?year=${request.year}&half=${request.halfYear}&depId=${request.depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getAml2XmlByDepsRequests({ depIdArray, year, halfYear, }: { year: string; halfYear: string | number; depIdArray: string[] | number[]; }) {
        return await server.post(`Reports/aml-2-by-deps-xml?year=${year}&half=${halfYear}&startCount=1`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml2XmlJsonRequests({ depIdArray, year, halfYear }: { year: string; halfYear: string | number; depIdArray: number[]; }) {
        return await server.post(`Reports/json/aml2-by-deps?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml3XmlRequests(request: { year: string; halfYear: string | number; depId: string | number; }) {
        return await server.post(`Reports/aml3xml?year=${request.year}&half=${request.halfYear}&depId=${request.depId}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getAml3XmlByDepsRequests({ depIdArray, year, halfYear, }: { year: string; halfYear: string | number; depIdArray: string[] | number[]; }) {
        return await server.post(`Reports/aml-3-by-deps-xml?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getAml3XmlJsonRequests({ depIdArray, year, halfYear }: { year: string; halfYear: string | number; depIdArray: number[]; }) {
        return await server.post(`Reports/json/aml3-by-deps?year=${year}&half=${halfYear}`,
            depIdArray,
            {
                baseURL: BACKEND_URL
            }
        );
    }

    async getTimesheetRequests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }) {
        return await server.post(`CashierReport/CashierTimeManagement`, {
            depId,
            from: from,
            to: to,
        }, {
            baseURL: BACKEND_URL
        });
    }

    /** История изменения курсов: операции по индивидуальному курсу с курсами НБ и стандартным на момент установки */
    async getIndividualOperations(filter: IndividualOperationsFilter): Promise<IndividualOperationModel[]> {
        return await server.post('/Reports/individual-operations', filter, {
            baseURL: BACKEND_URL
        });
    }

    /** Тот же отчёт файлом .xlsx */
    async exportIndividualOperations(filter: IndividualOperationsFilter): Promise<Blob> {
        return await server.post('/Reports/individual-operations/excel', filter, {
            baseURL: BACKEND_URL,
            responseType: "blob",
        });
    }
}
